<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="synopsis">
            <div class="container">
                <div class="center-box">
                    <div class="text-box">
                        <h4>{{ xName }}</h4>
                        <span>发布时间：{{ dataList.edittime }}&nbsp;&nbsp; | &nbsp;&nbsp; 来源：{{ dataList.source }}</span>
                    </div>
                    <div class="content-box">
                        <div class="content-box-text" v-html="dataList.content" />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="mobile">
            <div class="head">
                <img src="../../../assets/images/index/zjt.png" alt="" @click="fallback">
                <div>协会章程</div>
            </div>
            <div v-html="dataList.content" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dataList: {},
            xName: '协会章程',
            bannerList: []
        }
    },
    mounted() {
        this.dataRequest()
        this.bannerRequest()
    },
    methods: {
        dataRequest() {
            this.$api.get('webInfo/agreementInfo').then(res => {
                this.dataList = res.data
            })
        },
        bannerRequest() {
            this.$api.get('banner/qList').then(res => {
                this.bannerList = res.data.list
            })
        },
        fallback() {
            this.$router.go(-1)
        }
    }

}

</script>

<style lang="scss" scoped>
.synopsis {
    .case-container {
        width: 1920px;
        margin: 0 auto;
        position: relative;
        top: 0;
        font-size: 0;
        .swiper-container {
            height: 100%;
            font-size: 0;
            .swiper-slide img {
                width: 100%;
                height: 100%;
                display: block;
                font-size: 0;
            }
            img {
                vertical-align: buttom;
                vertical-align: middle;
                vertical-align: top;
            }
            .swiper-slide { height: 10px; }
            .swiper-slide-active { height: auto; }
        }
        .new-list {
            position: absolute;
            top: 0;
            right: 380px;
            z-index: 99;
        }
        #map {
            width: 500px;
            height: 500px;
        }
        .bannar-box {
            width: 1920px;
            height: 360px;
            img {
                width: 100%;
            }
        }
    }
    .container {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .center-box {
            background-color: rgba(255, 255, 255, 1);
            margin: 0 auto;
            margin-bottom: 60px;
            position: relative;
            .text-box {
                width: 1000px;
                height: 190px;
                border-bottom: 1px solid  rgba(238, 238, 238, 1);
                margin: 0 auto;
                h4 {
                    font-size: 30px;
                    font-weight: 400;
                    color: rgba(71, 71, 71, 1);
                    line-height: 30px;
                    margin-bottom: 12px;
                    text-align: center;
                }
                span {
                    font-size: 12px;
                    font-weight: 400;
                    display: block;
                    color: rgba(153, 153, 153, 1);
                    line-height: 24px;
                    text-align: center;
                    margin-top: 20px;
                }
            }
            .content-box {
                img {
                    width: 750px;
                    height: 320px;
                    margin: 0 auto;
                }
                .content-box-text {
                    padding: 34px;
                    p {
                        img {
                            width: 100%;
                        }
                    }
                }
                .paging {
                    width: 100%;
                    position: absolute;
                    bottom: 40px;
                    .nav-paging {
                        display: flex;
                        justify-content: space-around;
                        width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 24px;
                        .nothing {
                            color: #999;
                        }
                        .icon {
                            width: 4px;
                            margin: 0 10px;
                            color: #999;
                        }
                        span {
                            display: block;
                            width: 180px;
                            text-align: right;

                            /* 设置文本框大小 */
                            white-space: nowrap;

                            /* 设置内容不换行 */
                            text-overflow: ellipsis;

                            /* 设置文字超出文本框的内容显示成... */
                            overflow: hidden;
                            &:last-child {
                                text-align: left;
                            }
                            a {
                                text-decoration: none;
                                font-size: 12px;
                                font-weight: 400;
                                color: #273db4;
                                line-height: 24px;
                            }
                        }
                    }
                }
            }
        }
    }
}
.mobile {
    padding: 0 15px;
    .head {
        height: 60px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        img {
            width: 10px;
            height: 16px;
        }
        div {
            flex: 1;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            margin-left: 20px;
            color: #000;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            line-height: 16px;
        }
    }
}
</style>
